import React from 'react';
import { Users } from 'lucide-react';
import { useToast } from '../../../../../components/common/Toast';
import { useAccessTheme } from '../useAccessTheme';
import IdentityProviderModalShell from './IdentityProviderModalShell';

interface ScimSetupModalProps {
  onClose: () => void;
}

const ScimSetupModal: React.FC<ScimSetupModalProps> = ({ onClose }) => {
  const t = useAccessTheme();
  const { showToast } = useToast();

  const labelCls = 'block text-xs font-medium mb-1 ' + t.muted;
  const inputCls = 'w-full border rounded-lg px-3 py-2 text-sm outline-none ' + t.input;

  return (
    <IdentityProviderModalShell
      title="Configure SCIM 2.0"
      icon={<Users className="w-5 h-5" />}
      onClose={onClose}
      footer={
        <button
          type="button"
          onClick={() => showToast({ type: 'info', message: 'SCIM token generation is not available yet.' })}
          className={'px-4 py-2 rounded-lg text-sm font-medium ' + t.btnPrimary}
        >
          Generate Token
        </button>
      }
    >
      <div>
        <label className={labelCls}>SCIM Endpoint</label>
        <input
          type="text"
          value="https://example.com/scim/v2"
          readOnly
          className={inputCls + ' opacity-80'}
        />
      </div>
      <div>
        <label className={labelCls}>Provisioning Token</label>
        <input
          type="text"
          value="••••••••••••••••"
          readOnly
          className={inputCls + ' opacity-80'}
        />
      </div>
    </IdentityProviderModalShell>
  );
};

export default ScimSetupModal;
